import {onFind} from "@elements/init-modules-in-scope";
import {findIn} from "@elements/dom-utils";

export function init() {
    onFind('.js-consent-overlay', (overlay) => {
        let consentAcceptButton = findIn('.js-consent__accept-btn', overlay);
        consentAcceptButton.addEventListener('click', () => {
            Cookiebot.submitCustomConsent(true, true, true);
            setTimeout(function () {
                window.location.reload(true);
            }, 200);
        });
    });

    onFind('.js-consent-overlay__script', (scriptElement) => {
        if (
            Cookiebot.consent.necessary&&
            Cookiebot.consent.preferences &&
            Cookiebot.consent.statistics &&
            Cookiebot.consent.marketing
        ) {

            if (scriptElement && !scriptElement.src) {
                scriptElement.src = "https://apps.elfsight.com/p/platform.js";
            }
        }
        window.addEventListener('CookiebotOnAccept', function () {
            if (!sessionStorage.getItem('cookieConsentReloaded')) {
                sessionStorage.setItem('cookieConsentReloaded', 'true');
                window.location.reload(true);
            }
        });
    });
}